module.exports = __webpack_public_path__ + "static/media/chl.36eb77f7.png";